import React from "react";
import ElementEdit from "./ElementEdit";
import ElementDetailDefault from "./ElementDetailDefault";
import ElementTabs from "./ElementTabs";
import ElementSpare from "./ElementSpare";
import PropertyEdit from "../Property/PropertyEdit";
import ElementOperation from "./ElementOperation";
import ElementMaint from "./ElementMaint";
import Context from "../../../Context";
import EssenceFiles from "../../Essence/EssenceFiles";

export default class ElementDetail extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      notFound: false,
      pending: false,
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elementId !== this.props.elementId) {
      this.load();
    }
  }

  load = async () => {
    const { elementId } = this.props;
    if (!elementId || elementId === "add") return;
    this.setState({ pending: true });
    let item = await this.context.api.q("/element/get", {
      id: elementId,
    });
    this.setState({
      pending: false,
      item: item,
      notFound: !item,
    });
  };

  onAfterSave = (item) => {
    this.load();
    if (this.props.onAfterSave) {
      this.props.onAfterSave(item);
    }
  };

  render() {
    let { mode, elementId } = this.props;
    let displayMode = mode;
    if (elementId === "add") displayMode = "edit";
    if (mode === "add") displayMode = "edit";
    return (
      <>
        {displayMode !== "edit" && (
          <ElementTabs element={this.state.item} {...this.props} />
        )}
        {displayMode === "default" && <ElementDetailDefault {...this.props} />}
        {displayMode === "edit" && (
          <ElementEdit {...this.props} onAfterSave={this.onAfterSave} />
        )}
        {displayMode === "spare" && <ElementSpare {...this.props} />}
        {displayMode === "operation" && <ElementOperation {...this.props} />}
        {displayMode === "maint" && <ElementMaint {...this.props} />}
        {displayMode === "properties" && (
          <PropertyEdit
            objectId={this.props.elementId}
            reference="element"
            referencekey="elementid"
          />
        )}
        {displayMode === "files" && (
          <EssenceFiles
            essence="element"
            id={this.props.elementId}
            key={this.props.elementId}
          />
        )}
      </>
    );
  }
}
